type Listener = () => void;

let hasLoginExpiredNotificationShown = false;
const listeners = new Set<Listener>();

// Prevent duplicate login-expired prompts while allowing global subscribers to react.
export function notifyLoginExpired() {
    // 如果当前页面是 /event-preview，不需要进行登录验证
    if ( typeof window !== "undefined" && window.location.pathname.startsWith( "/event-preview" ) ) {
        return;
    }

    if ( hasLoginExpiredNotificationShown ) return;
    hasLoginExpiredNotificationShown = true;
    listeners.forEach( listener => listener() );
}

export function subscribeLoginExpired( listener: Listener, options: { immediate?: boolean } = {} ) {
    listeners.add( listener );

    if ( options.immediate && hasLoginExpiredNotificationShown ) {
        listener();
    }

    return () => {
        listeners.delete( listener );
    };
}

export function resetLoginExpiredNotification() {
    hasLoginExpiredNotificationShown = false;
}

export function hasShownLoginExpiredNotification() {
    return hasLoginExpiredNotificationShown;
}
